import { render, staticRenderFns } from "./KycRequest.vue?vue&type=template&id=b063904c&"
import script from "./KycRequest.vue?vue&type=script&lang=js&"
export * from "./KycRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports